import {
  InputField,
  Button,
  Spinner,
  PersonalizedQuestions,
  ErrorMessage,
  Heading,
  SuccessPopup,
} from "@/common/components";
import { useContext, useState } from "@/common/hooks";
import { PublicContext } from "@/routes/PublicRoute";
import {
  useRetrieveCustomOperatorIdQuery,
  useRetrieveOperatorIdMutation,
} from "@/service/APIService";
import { validate } from "@/utils/Validations";

export default function ForgotOperator() {
  const { labels, cancel, skipToken, debounceState, debounceErrors, uniqueId } =
    useContext(PublicContext);
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({ email: "" });
  const [params, setParams] = useState(skipToken);
  const [questions, setQuestions] = useState({
    questionOne: "",
    questionTwo: "",
  });
  const [showPopup, setShowPopup] = useState(false);
  const [operatorId, setOperatorId] = useState("");

  const {
    data: challengeQuestion,
    isFetching,
    error,
  } = useRetrieveCustomOperatorIdQuery(params);

  const [retrieveOperatorId, { isFetching: isFetching1, error: error1 }] =
    useRetrieveOperatorIdMutation();

  const checkDisabled = () => {
    if (challengeQuestion) {
      return !(questions?.questionOne && questions?.questionTwo);
    } else {
      return errors?.email || !email;
    }
  };

  const doSearch = () => {
    if (challengeQuestion) {
      retrieveOperatorId({
        questionOne: questions.questionOne.toLowerCase(),
        questionTwo: questions.questionTwo.toLowerCase(),
        customOperatorId: challengeQuestion.operatorId,
      })
        .unwrap()
        .then((res) => {
          setShowPopup(true);
          setOperatorId(res?.customUserId);
        });
    } else {
      setParams({ emailId: email, id: uniqueId() });
    }
  };

  return (
    <section className="container-medium py-5 px-3">
      {(isFetching || isFetching1) && <Spinner />}
      <Heading
        text={labels?.forgotOperator?.retrieveOperatorId}
        wrapperClassNames="text-center mb-5"
      />
      <ErrorMessage error={error || error1} wrapperClassName="mb-3" />
      {!challengeQuestion ? (
        <InputField
          id="email"
          label={labels?.forgotOperator?.email}
          type="email"
          wrapperClassName="mb-4"
          value={email}
          change={async (e) => {
            debounceState(e, setEmail);
            debounceErrors({ email: await validate(e, "email") }, setErrors);
          }}
          error={errors.email}
          touched={email}
        />
      ) : (
        <>
          <div className="mt-n2 mb-3">
            <strong>{labels?.forgotOperator?.email}:</strong> {email}
          </div>
          <PersonalizedQuestions
            labelOne={challengeQuestion.challengeQuestion1 + "*"}
            labelTwo={challengeQuestion.challengeQuestion2 + "*"}
            questions={questions}
            setQuestions={setQuestions}
          />
        </>
      )}

      <div className="d-flex align-items-center justify-content-end gap-1">
        <Button
          id="cancel"
          text={labels?.forgotOperator?.cancel}
          click={cancel}
          type="secondary"
          wrapperClassName="col-md-3 col-6"
        />
        <Button
          id="searchOrRetrieve"
          text={
            challengeQuestion
              ? labels?.forgotOperator?.retrieveId
              : labels?.forgotOperator?.search
          }
          wrapperClassName="col-md-3 col-6"
          click={doSearch}
          disabled={checkDisabled()}
        />
      </div>
      <SuccessPopup
        showModal={showPopup}
        buttonText={labels?.forgotOperator?.goToLogin}
        click={cancel}
        body={labels?.forgotOperator?.yourOperatorIs?.replace(
          "operatorId",
          operatorId
        )}
      />
    </section>
  );
}
